import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { ModuleFE_VolatileImport } from '../ModuleFE_VolatileImport.js';
import './Panel_DiseaseProfileImportErrors.scss';
/**
 * Validation-errors panel for a volatile disease-profile preview, rendered into the
 * `disease-profile-import-errors` slot over the manager region. Renders nothing when there are no
 * errors for the active import. Mirrors Panel_PathwayImportErrors.
 *
 * Errors live in `ModuleFE_VolatileImport`; since the Save button (which triggers the save that may
 * produce new errors) is a separate component, this panel re-derives on the module's DP validation
 * dispatcher rather than on host re-renders.
 */
export class Panel_DiseaseProfileImportErrors extends ComponentSync {
    __onDiseaseProfileImportValidationErrorsUpdated = (importId) => {
        if (importId !== this.state.importId)
            return;
        this.reDeriveState({ panelClosed: false });
    };
    deriveStateFromProps(nextProps, state) {
        state.collapsedCodes ??= new Set();
        state.panelClosed ??= false;
        state.importId = ModuleFE_VolatileImport.getImportIdForDiseaseProfile(nextProps.tabId, nextProps.diseaseProfileId);
        state.errors = state.importId ? ModuleFE_VolatileImport.getDiseaseProfileValidationErrors(state.importId) : [];
        return state;
    }
    groupByCode = (errors) => {
        const map = new Map();
        for (const error of errors)
            (map.get(error.code) ?? map.set(error.code, []).get(error.code)).push(error);
        return Array.from(map, ([code, items]) => ({ code, items }));
    };
    toggleGroup = (code) => {
        const collapsedCodes = new Set(this.state.collapsedCodes);
        collapsedCodes.has(code) ? collapsedCodes.delete(code) : collapsedCodes.add(code);
        this.setState({ collapsedCodes });
    };
    render() {
        const { errors, panelClosed } = this.state;
        if (!errors.length)
            return null;
        if (panelClosed)
            return _jsx("button", { className: 'panel-disease-profile-import-errors__reopen', onClick: () => this.setState({ panelClosed: false }), children: `Issues (${errors.length})` });
        return _jsxs(LL_V_L, { className: 'panel-disease-profile-import-errors', children: [_jsxs(LL_H_C, { className: 'panel-disease-profile-import-errors__header', children: [_jsx("span", { className: 'title-text', children: `Import issues (${errors.length})` }), _jsx(ICONS.x.component, { className: 'exit_icon', onClick: () => this.setState({ panelClosed: true }) })] }), _jsx(LL_V_L, { className: 'panel-disease-profile-import-errors__body', children: this.groupByCode(errors).map(({ code, items }) => this.renderGroup(code, items)) })] });
    }
    renderGroup = (code, items) => {
        const collapsed = this.state.collapsedCodes.has(code);
        return _jsxs(LL_V_L, { className: 'panel-disease-profile-import-errors__group', children: [_jsxs(LL_H_C, { className: 'panel-disease-profile-import-errors__group-header', onClick: () => this.toggleGroup(code), children: [_jsx(ICONS.advisor_v4_arrow.component, { className: `panel-disease-profile-import-errors__caret${collapsed ? ' collapsed' : ''}` }), _jsx("span", { className: 'panel-disease-profile-import-errors__group-title', children: `${code} (${items.length})` })] }), !collapsed &&
                    _jsx(LL_V_L, { className: 'panel-disease-profile-import-errors__group-body', children: items.map((error, index) => this.renderError(error, index)) })] }, code);
    };
    renderError = (error, index) => _jsxs(LL_V_L, { className: 'panel-disease-profile-import-errors__error', children: [_jsx("span", { className: 'panel-disease-profile-import-errors__error-message', children: error.message }), (error.dbKey || error.csvId) &&
                _jsxs(LL_H_C, { className: 'panel-disease-profile-import-errors__error-meta', children: [error.dbKey && _jsx("span", { className: 'panel-disease-profile-import-errors__error-chip', children: error.dbKey }), error.csvId && _jsx("span", { className: 'panel-disease-profile-import-errors__error-chip', children: error.csvId })] })] }, index);
}
//# sourceMappingURL=Panel_DiseaseProfileImportErrors.js.map